import { Inject, Injectable } from '@angular/core';
import { getId, isset } from '@cawita/core-front';
import { CwtStorageService } from '@cawita/core-front/storage';
import { CWT_APP_CONFIG, CwtAppConfig } from '@mobile/modules/core/core-app.config';
import { Partner } from '@shared/models';

@Injectable({ providedIn: 'root' })
export class StayStorage {
    private _lastPartnerId: string | null = null;

    constructor(
        @Inject(CWT_APP_CONFIG) private appConfig: CwtAppConfig,
        private storage: CwtStorageService
    ) {
        this._lastPartnerId = storage.getString(this.appConfig.stay.storageKey) ?? null;
    }

    public getLastPartnerId(): string | undefined {
        return this._lastPartnerId;
    }

    public setLastPartnerId(partner: Partner | string) {
      this._lastPartnerId = getId(partner) ?? null;
      if(!isset(this._lastPartnerId)) this.storage.remove(this.appConfig.stay.storageKey);
      else this.storage.setString(this.appConfig.stay.storageKey, this._lastPartnerId);
    }
}